import React from "react";
import { Button } from "react-bootstrap";
import { LiveOrdersBlockedProductFilter } from "../../../services/types";

interface Props {
	id: LiveOrdersBlockedProductFilter;
	title: string;
	isSelected: boolean;
	setSelectedFilter: React.Dispatch<React.SetStateAction<LiveOrdersBlockedProductFilter>>;
	amount?: number;
}

const LiveOrdersBlockedItemsFilterButton = ({ id, title, isSelected, setSelectedFilter, amount }: Props) => {
	return (
		<Button variant={`${isSelected ? "outline-primary" : "outline-dark"}`} onClick={() => setSelectedFilter(id)}>
			{`${title}${amount !== undefined ? ": " : ""}`}
			{amount !== undefined ? <span className={amount > 0 ? "text-danger" : "text-muted"}>{amount}</span> : <></>}
		</Button>
	);
};

export default LiveOrdersBlockedItemsFilterButton;
